import { useEffect, useState } from "react";
import { providerPayoutBalnce } from "../../../config/LiveApi";
import { Close } from "@mui/icons-material";
import DataTable from "../../../components/common/DataTable/DataTable";

const ProviderBalanceModal = ({ setShowModal }) => {
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await providerPayoutBalnce();
      console.log("Provider Balance Response:", response);
      setProviderData(response || []);
    } catch (err) {
      console.error("Error fetching provider balance rate:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      key: "serialNo",
      header: "S.No",
      render: (_, index) => index + 1,
    },
    {
      key: "organization",
      header: "OrgName",
      render: (row) => row.organization || "N/A",
    },
    {
      key: "provider",
      header: "Provider Name",
      render: (row) => row.provider || "N/A",
    },
    {
      key: "balance",
      header: "Balance(₹)",
      render: (row) => (
        <span className="blanceText">{row.balance || "N/A"}</span>
      ),
    },
  ];

  return (
    <div className="overlay-provider-success">
      <div className="modal-provider-success">
        <div className="modal-header-provider-success">
          <h3 className="title-provider-success">📊 ₹ Provider Balance</h3>
          <Close
            onClick={() => setShowModal(false)}
            className="close-btn-provider-success"
          />
        </div>

        <div className="table-wrapper-provider-success">
          <DataTable
            columns={columns}
            data={providerData}
            loading={loading}
            emptyMessage="No Provider data available."
          />
        </div>

        {/* <div className="buttons-provider-success">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="close-btn-provider-success"
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ProviderBalanceModal;
